import script from "./handoff.vue?vue&type=script&setup=true&lang=js"
export * from "./handoff.vue?vue&type=script&setup=true&lang=js"

import "./handoff.vue?vue&type=style&index=0&id=7b671bf3&lang=less&scoped=true"

import exportComponent from "D:\\zykj_programs\\verdue-crm-customer\\master\\verdue-crm-customer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b671bf3"]])

export default __exports__